import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	buttonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	buttonText: {
		id: 'jql-builder-basic.jql-editor.order-by-picker.footer.button-text',
		defaultMessage: 'Clear selection',
		description: 'the text on the button to remove all order by selections',
	},
});

export default messages;
